// extracted by mini-css-extract-plugin
export default {"videoSection":"videoSection__MzMxO","sectionHr":"sectionHr__ZTYwY"};